import { j as i } from "./jsx-runtime-944c88e2.js";
import { forwardRef as c } from "react";
import { i as l } from "./index-7c241c5b.js";
import { c as s } from "./form-2514c6d8.js";
import { w as d } from "./form-field-wrapper.hoc-d784197f.js";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./index-93802845.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./index.es-6889c727.js";
import "./FloatingLabel-922c628f.js";
import "./package-metadata-3dcf116a.js";
import "./Popup-b6c9078b.js";
import "./ActionSheet-b5bf2237.js";
import "./Animation-154b683d.js";
import "./TransitionGroup-34043d49.js";
import "./noop-d627517c.js";
import "./package-metadata-a152adb8.js";
import "./FormElement-65f04cfd.js";
import "./Label-079ad7bc.js";
const o = c(function(r, m) {
  const t = r.placeholder === "" ? r.label : r.placeholder;
  return /* @__PURE__ */ i.jsx(l, { ...r, ref: m, placeholder: t });
});
o.displayName = "TimePicker";
const G = ({
  validationMessage: e,
  touched: r,
  modified: m,
  visited: t,
  hint: n,
  fieldWrapperClassName: p,
  ...a
}) => /* @__PURE__ */ i.jsx(s, { className: p, children: /* @__PURE__ */ i.jsx(o, { ...a }) }), I = d(o);
export {
  G as FormElementTimePicker,
  o as TimePicker,
  I as TimePickerFormField
};
